import React from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";

const DOMAIN = "https://thevirtue.co";
const LANGS = ["en", "fr", "tr", "nl"];
const DEFAULT_LANG = "en";

export default function SEO({ slug }) {
  const { lang } = useParams();
  const active = LANGS.includes(lang) ? lang : DEFAULT_LANG;
  const canonical = `${DOMAIN}/${active}/${slug}`;

  return (
    <Helmet>
      <link rel="canonical" href={canonical} />
      {LANGS.map((code) => (
        <link
          key={code}
          rel="alternate"
          hreflang={code}
          href={`${DOMAIN}/${code}/${slug}`}
        />
      ))}
      <link
        rel="alternate"
        hreflang="x-default"
        href={`${DOMAIN}/${DEFAULT_LANG}/${slug}`}
      />
    </Helmet>
  );
}
